/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState, useRef} from 'react'
import {Controller, FormProvider, useForm} from 'react-hook-form'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {KTableLoading} from '../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {InputNumberWrapper, SelectWrapper} from '../../../../../components/UI/Form/Input'
import {SelectOption} from '../../../../../models/utility.model'
import {useCentralServices} from '../../../hooks/useCentralServices'
import Chart from 'react-apexcharts'
import {ApexOptions} from 'apexcharts'
import {OccupancyReportDTO, OccupancyTableReportDTO} from '../../../models/reports.model'
import {yupResolver} from '@hookform/resolvers/yup'
import {reportOccupancySchema} from '../../../../../util/validationHoteleria'
import {getOccupancyReportList, getDailyOccupancyReportList} from '../../../services/report.service'
import {formatDateDDMMYYYY, formatDateUTC} from '../../../../../util/dates'
import {TableReportOccupancy} from './Tables/TableReportOccupancy'
import {getFactConfigByValueId} from '../../../../central/services/configFacturation.service'
import {getListBillingExcelService} from '../../../services/billing.service'
import moment from 'moment'
import {getSnackBarToast} from '../../../../../util/snackBar'
import {useAuth} from '../../../../../hooks/useAuth'
import {useHoteleria} from '../../../../../hooks/useHoteleria'
const ReportOccupancy: FC = () => {
  const {currentTabItem} = useHoteleria()
  const {user} = useAuth()
  const optionsChartOccupancy: ApexOptions = {
    title: {
      text: '',
      align: 'center',
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        fontFamily: 'Arial, sans-serif',
      },
    },
    chart: {
      id: 'inspections-schedule',
      type: 'line',
      width: '100%',
      animations: {
        enabled: true,
        speed: 800,
      },
      toolbar: {
        show: true,
      },
      selection: {
        enabled: false,
      },
      zoom: {
        enabled: false,
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top',
        },
      },
    },
    legend: {
      show: false,
    },
    xaxis: {
      type: 'category',
      categories: [],
      tooltip: {
        enabled: true,
      },
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 'bolder',
          colors: ['#000'],
        },
        maxHeight: 180,
      },
    },
    yaxis: [
      {
        show: true,
        tooltip: {
          enabled: false,
        },
      },
    ],
    tooltip: {
      custom: function ({seriesIndex, dataPointIndex, w}) {
        const value = w.globals.series[seriesIndex][dataPointIndex]
        if (value !== undefined && value !== null) {
          return `<div class="arrow_box" style="display: flex; flex-direction: row; justify-content: center; align-items: center; padding: 2px; font-size: 16px;">
                    <div style="width: 10px; height: 10px; background: #5dade2; border-radius: 50px; margin-right: 7px;"></div>
                    <span style="margin-right: 7px;">Nro de Estadías: </span>
                    <span style="font-weight: bold;">${value}</span>
                  </div>`
        }
        return ''
      },
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
      style: {
        colors: [
          function ({value, seriesIndex, w, dataPointIndex}: any) {
            return 'rgba(0,143,251,0.85)'
          },
        ],
      },
    },
    stroke: {
      width: [0, 4],
    },
    series: [
      {
        name: '',
        type: 'bar',
        data: [],
      },
      {
        name: '',
        type: 'bar',
        data: [],
      },
      {
        name: '',
        type: 'line',
        data: [],
      },
    ],
  }

  const methods = useForm<any>({
    resolver: yupResolver(reportOccupancySchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
      nroDiaInicio: '',
      nroDiaFin: '',
    },
  })

  const {setValue, handleSubmit, setError, watch, control} = methods
  const [chartData, setChartData] = useState<ApexOptions>(optionsChartOccupancy)
  const [searching, setSearching] = useState(false)
  const [loading, setLoading] = useState(false)
  const [valueForm, setValueForm] = useState<OccupancyTableReportDTO>({})
  const [dataMonthly, setDataMonthly] = useState<any>([])
  const [company, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [sites, setSites] = useState<SelectOption[]>([])
  const [camps, setCamps] = useState<SelectOption[]>([])
  const [hasData, setHasData] = useState<boolean>(false)
  const [optionText, setOptionText] = useState<string>('monthly')
  const [changeDate, setChangeDate] = useState<boolean>(false)
  const [showSearch, setShowSearch] = useState<boolean>(false)
  const [promedioEstadias, setPromedioEstadias] = useState<number>(0)
  const [totalEstadias, setTotalEstadias] = useState<number>(0)
  const [tituloGrafico, setTituloGrafico] = useState<string>('')
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [periodDayli, setPeriodDayli] = useState<any>([])
  const [isSearchEmp, setIsSearchEmp] = useState<boolean>(false)
  const [idEmpresa, setIdEmpresa] = useState<string>('')

  const textRef = useRef(optionText)

  useEffect(() => {
    textRef.current = optionText
  }, [optionText])

  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
      await getValuesDays(data[0].value as string)
    }
    setSites(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    const allData = [{value: '4EsB2NAAsDA=', label: 'TODOS'}, ...data]
    setCamps(allData)
  }

  const getValuesDays = async (id: string) => {
    try {
      const {data} = await getFactConfigByValueId(
        id,
        watch('ClienteId'),
        user.applicationId,
        currentTabItem.vistaId,
      )
      if (!data.error) {
        setValue('nroDiaInicio', data.data?.ValorInicio || '')
        setValue('nroDiaFin', data.data?.ValorFin || '')
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  function obtenerRangoFechas(data: {FechaEstadia: string; NroEstadias: number}[]) {
    data.sort(
      (a: any, b: any) => new Date(a.FechaEstadia).getTime() - new Date(b.FechaEstadia).getTime(),
    )
    let primeraFecha = null
    let ultimaFecha = null
    if ((data || []).length) {
      primeraFecha = new Date(data[0].FechaEstadia)
      primeraFecha.setHours(primeraFecha.getHours() + 5)
      ultimaFecha = new Date(data[data.length - 1].FechaEstadia)
      ultimaFecha.setHours(ultimaFecha.getHours() + 5)
    }
    if (primeraFecha && ultimaFecha) {
      const opciones = {year: 'numeric', month: 'long', day: 'numeric'}
      const fechaPrimera = primeraFecha.toLocaleDateString('es-ES', opciones)
      const fechaUltima = ultimaFecha.toLocaleDateString('es-ES', opciones)
      return `${fechaPrimera} - ${fechaUltima}`.toUpperCase()
    } else {
      return 'No hay estadías válidas'
    }
  }

  function obtenerDiaDeFecha(fecha: string): string {
    const date = new Date(fecha)
    return date.getUTCDate().toString() // Obtiene el día del mes (1-31)
  }

  function calcularPromedioEstadias(array: {x: number; y: number; fillColor: string}[]): number {
    try {
      const suma = array.reduce((total, objeto) => {
        return total + (objeto.y || 0)
      }, 0)
      const promedio = suma / array.length
      return promedio
    } catch (error) {
      return 0
    }
  }

  function calcularTotalEstadias(array: {x: number; y: number; fillColor: string}[]): number {
    try {
      const suma = array.reduce((total, objeto) => {
        return total + (objeto.y || 0)
      }, 0)
      return suma
    } catch (error) {
      return 0
    }
  }

  function fomartDataForChartCustom(data: any, colors: boolean) {
    function obtenerColor(valor: number, mayorMenor: {max: number; min: number}, colors: boolean) {
      if (colors) {
        if (valor === mayorMenor.max) {
          return '#58d68d'
        } else if (valor === mayorMenor.min) {
          return '#ff5733'
        } else {
          return '#5dade2'
        }
      } else {
        return '#5dade2'
      }
    }

    let mayorMenor: {max: number; min: number} = {
      max: -Infinity,
      min: Infinity,
    }

    data.forEach((item: any) => {
      if (item.NroEstadias > 0) {
        if (item.NroEstadias > mayorMenor.max) {
          mayorMenor.max = item.NroEstadias
        }
        if (item.NroEstadias < mayorMenor.min) {
          mayorMenor.min = item.NroEstadias
        }
      }
    })

    const result = data.map((item: any, index: number) => ({
      x: index + 1,
      y: item.NroEstadias,
      fillColor: obtenerColor(item.NroEstadias, mayorMenor, colors),
    }))

    return result
  }

  function fomartDataForChartCustomByEmp(data: any, colors: boolean) {
    function obtenerColor(valor: number, mayorMenor: {max: number; min: number}, colors: boolean) {
      if (colors) {
        if (valor === mayorMenor.max) {
          return '#119448' // Color verde para el valor máximo
        } else if (valor === mayorMenor.min) {
          return '#ff5733' // Color rojo para el valor mínimo
        } else {
          return '#124f77' // Color azul para otros valores
        }
      } else {
        return '#467da2'
      }
    }

    let mayorMenor: {max: number; min: number} = {
      max: -Infinity,
      min: Infinity,
    }

    data.forEach((item: any) => {
      if (item.NroEstadias > 0) {
        if (item.NroEstadias > mayorMenor.max) {
          mayorMenor.max = item.NroEstadias
        }
        if (item.NroEstadias < mayorMenor.min) {
          mayorMenor.min = item.NroEstadias
        }
      }
    })

    const result = data.map((item: any, index: number) => ({
      x: index + 1,
      y: item.NroEstadias,
      fillColor: obtenerColor(item.NroEstadias, mayorMenor, colors),
    }))

    return result
  }

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setValue('CampamentoId', '')
    setCamps([])
    setError('CompaniaId', {})
    getClientsFn(value)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
    setError('ClienteId', {})
    getSitesFn(value)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    setError('SiteId', {})
    getCampsFn(value)
    getValuesDays(value)
  }

  const handleClear = () => {
    setValue('nroDiaInicio', '')
    setValue('nroDiaFin', '')
    setValue('CompaniaId', '')
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setPromedioEstadias(0)
    setTotalEstadias(0)
    setClient([])
    setSites([])
    setCamps([])
    setValueForm({})
    setChangeDate(true)
    setHasData(false)
    setChartData(optionsChartOccupancy)
  }

  const handleBackToMonthly = () => {
    setChartData({})
    setOptionText('monthly')
    setHasData(false)
    createPeriodosChart(dataMonthly, valueForm, optionText)
  }

  const createPeriodosChart = (periodos: any, dataForm: any, text: string) => {
    const seriesPorcentaje = fomartDataForChartCustom(periodos, false)
    const categories = periodos.map(
      (item: any) =>
        formatDateDDMMYYYY(item.FechaDesde) + ' - ' + formatDateDDMMYYYY(item.FechaHasta),
    )

    const promedio = calcularPromedioEstadias(seriesPorcentaje)
    setPromedioEstadias(promedio)
    setTituloGrafico('')
    setChartData((prevState: any) => {
      const newstate = {
        ...optionsChartOccupancy,
        title: {...optionsChartOccupancy.title, text: 'Gráfica de Ocupabilidad'},
        xaxis: {
          ...optionsChartOccupancy.xaxis,
          categories: categories,
          tickAmount: periodos.length - 2,
          range: periodos.length - 1,
          labels: {...optionsChartOccupancy.xaxis.labels, rotate: -45},
        },
        stroke: {width: [0, 4]},
        series: [
          {
            name: 'Nro de Estadías',
            type: 'column',
            data: seriesPorcentaje,
          },
          {
            name: 'Periodo',
            type: 'line',
            data: seriesPorcentaje,
          },
        ],
        chart: {
          ...optionsChartOccupancy.chart,
          events: {
            dataPointSelection: async (event: any, chartContext: any, config: any) => {
              setValue('HuespedDetId', '')
              setValue('Huesped_descripcion', '')
              setValue('EmpresaId', '')
              setValue('EmpresaNombre', '')
              setValue('ModuloId', '')
              setValue('ModuloCodigo', '')
              setValue('HabitacionId', '')
              setValue('HabitacionCodigo', '')
              setValue('CamaId', '')
              setValue('CamaCodigo', '')
              if (textRef.current === 'monthly') {
                setHasData(false)

                const selectedIndex = config.dataPointIndex
                const xValue = categories[selectedIndex]
                let newDates = xValue.split(' ')

                const [dayI, monthI, yearI] = newDates[0].split('/') // Divide la fecha en partes
                const [dayF, monthF, yearF] = newDates[2].split('/') // Divide la fecha en partes
                try {
                  setLoading(true)
                  setOptionText('dayli')
                  const dailyData = await getDailyOccupancyReportList({
                    CompaniaId: dataForm.CompaniaId || '',
                    ClienteId: dataForm.ClienteId || '',
                    SiteId: dataForm.SiteId || '',
                    CampamentoId: dataForm.CampamentoId || '',
                    nroDiaInicio: formatDateUTC(`${yearI}-${monthI}-${dayI}`) || 0,
                    nroDiaFin: formatDateUTC(`${yearF}-${monthF}-${dayF}`) || 0,
                  })
                  if (dailyData.data && dailyData.data.length > 0) {
                    setHasData(true)
                    setPeriodDayli(dailyData.data)
                    createPeriodosDayliChart(dailyData.data)
                    if (
                      valueForm.FechaDesde !== newDates[0] &&
                      valueForm.FechaHasta !== newDates[2]
                    ) {
                      setValueForm((prevState) => ({
                        ...prevState,
                        FechaDesde: newDates[0],
                        FechaHasta: newDates[2],
                      }))
                      setChangeDate(true)
                      setShowSearch(true)
                    }
                  }
                } catch (error) {
                } finally {
                  setLoading(false)
                }
              }
            },
          },
        },
      }
      return newstate
    })
  }

  const createPeriodosDayliChart = (periodos: any) => {
    const categories = periodos.map((item: any) => obtenerDiaDeFecha(item.FechaEstadia))
    const seriesPorcentaje = fomartDataForChartCustom(periodos, true)

    const tituloPeriodo = obtenerRangoFechas(periodos)
    const promedio = calcularPromedioEstadias(seriesPorcentaje)
    const total = calcularTotalEstadias(seriesPorcentaje)
    setPromedioEstadias(promedio)
    setTotalEstadias(total)
    setTituloGrafico(tituloPeriodo)
    setChartData((prevState) => {
      const newstate = {
        ...prevState,
        title: {...prevState.title, text: ''},
        xaxis: {
          ...prevState.xaxis,
          categories: categories,
          tickAmount: periodos.length - 2,
          range: periodos.length - 1,
          labels: {...prevState.xaxis.labels, rotate: 0},
        },
        stroke: {width: [0, 2]},
        series: [
          {
            name: 'Nro de Estadías',
            type: 'bar',
            data: seriesPorcentaje,
          },
          {
            name: '',
            type: 'line',
            data: seriesPorcentaje,
          },
        ],
        chart: {
          ...prevState.chart,
          events: {
            dataPointSelection: async (event: any, chartContext: any, config: any) => {
              event.preventDefault()
            },
          },
        },
      }
      return newstate
    })
  }

  const handleGetPeriodEmp = async () => {
    const [dayI, monthI, yearI] = valueForm.FechaDesde.split('/') // Divide la fecha en partes
    const [dayF, monthF, yearF] = valueForm.FechaHasta.split('/') // Divide la fecha en partes
    const dailyData = await getDailyOccupancyReportList({
      CompaniaId: valueForm.CompaniaId || '',
      ClienteId: valueForm.ClienteId || '',
      SiteId: valueForm.SiteId || '',
      CampamentoId: valueForm.CampamentoId || '',
      nroDiaInicio: formatDateUTC(`${yearI}-${monthI}-${dayI}`) || '',
      nroDiaFin: formatDateUTC(`${yearF}-${monthF}-${dayF}`) || '',
      EmpresaId: idEmpresa,
    })

    if (dailyData.data && dailyData.data.length > 0) {
      setHasData(true)
      createPeriodosDayliChartByEmp(dailyData.data, periodDayli)
    }
  }

  const createPeriodosDayliChartByEmp = (periodos: any, periodo: any) => {
    const categories = periodos.map((item: any) => obtenerDiaDeFecha(item.FechaEstadia))
    const seriesPorcentaje = fomartDataForChartCustom(periodo, true)
    const seriesPorcentaje1 = fomartDataForChartCustomByEmp(periodos, true)
    const seriesRestada = seriesPorcentaje.map((valor: any, index: number) => {
      return {
        ...valor,
        y: valor.y - (seriesPorcentaje1[index].y || 0),
      }
    })

    const seriesPorcentaje1Y = seriesPorcentaje.map((item) => item.y)
    setChartData((prevState: any) => {
      const newstate = {
        ...prevState,
        plotOptions: {},
        yaxis: {
          logarithmic: Math.max(...seriesPorcentaje1Y) < 1000, // Usamos escala lineal para asegurar que los valores pequeños sean visibles
          min: 0, // Un valor mínimo ajustado para que la barra más baja no quede en el borde
          // max: Math.max(...seriesPorcentaje1Y) * 2, // Establecemos un valor máximo con margen extra
          forceNiceScale: true, // Permite que el eje Y se ajuste automáticamente para que las barras no se "corten"
          labels: {
            formatter: (val) => Math.round(val), // Formateamos las etiquetas de los valores
          },
        },
        dataLabels: {
          ...prevState.dataLabels,
          enabledOnSeries: undefined,
          enabled: true, // Asegura que los data labels estén habilitados
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            colors: ['#000'],
          },
          textAnchor: 'middle',
          floating: true,
          // offsetY: -10,
        },
        xaxis: {
          ...prevState.xaxis,
          categories: categories,
        },
        stroke: {width: [0, 2]},
        series: [
          {
            name: 'Nro de Estadías por empresa',
            type: 'bar',
            data: seriesPorcentaje1,
          },
          {
            name: 'Nro de Estadías (Ajustado)',
            type: 'bar',
            data: seriesRestada,
          },
        ],
        chart: {
          stacked: true,
          stackType: 'normal',
          events: {
            dataPointSelection: async (event: any, chartContext: any, config: any) => {
              event.preventDefault()
            },
          },
        },
      }
      return newstate
    })
  }

  const onSubmit = async (dataForm: OccupancyReportDTO) => {
    setSearching(true)
    setValueForm(dataForm)
    setValue('HuespedDetId', '')
    setValue('Huesped_descripcion', '')
    setValue('EmpresaId', '')
    setValue('EmpresaNombre', '')
    setValue('ModuloId', '')
    setValue('ModuloCodigo', '')
    setValue('HabitacionId', '')
    setValue('HabitacionCodigo', '')
    setValue('CamaId', '')
    setValue('CamaCodigo', '')
    try {
      const resp = await getOccupancyReportList(dataForm)
      if (resp.data && resp.data.length > 0) {
        setDataMonthly(resp.data)
        createPeriodosChart(resp.data, dataForm, optionText)
        setOptionText('monthly')
      }
    } catch (error) {
      console.log({error})
    } finally {
      setSearching(false)
    }
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isSearchEmp) {
      setIsSearchEmp(false)
      handleGetPeriodEmp()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearchEmp])

  const handleExportXLS = async () => {
    const [dayI, monthI, yearI] = valueForm.FechaDesde.split('/') // Divide la fecha en partes
    const [dayF, monthF, yearF] = valueForm.FechaHasta.split('/') // Divide la fecha en partes
    try {
      setIsDownloadXLS(true)
      const obj = {
        pageNumber: 1,
        size: 10,
        FechaPeriodoIni: yearI + '-' + monthI + '-' + dayI,
        FechaPeriodoFin: yearF + '-' + monthF + '-' + dayF,
        ClienteId: valueForm.ClienteId,
        CampamentoId: valueForm.CampamentoId,
        ModuloId: null,
        HuespedId: null,
        TipoHabitacionId: null,
        HuespedDescripcion: 'TODOS',
      }
      const response = await getListBillingExcelService(obj)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Reporte de Facturacion-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  const handleChangeMesCompleto = (e: any) => {
    const valueChecked = e.target.checked
    setValue('nroDiaInicio', '')
    setValue('nroDiaFin', '')
    setError('nroDiaInicio', {})
    setError('nroDiaFin', {})
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Compañia'
                    name='CompaniaId'
                    data={company}
                    onChangeValue={handleCompanyChange}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Cliente'
                    name='ClienteId'
                    data={client}
                    onChangeValue={handleClientChange}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Site'
                    name='SiteId'
                    data={sites}
                    onChangeValue={handleSiteChange}
                    required
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper labelText='Campamento' name='CampamentoId' data={camps} required />
                </div>
              </div>
              <div className='row'>
                {!watch('mesCompleto') && (
                  <>
                    <div className='col-sm-12 col-lg-3'>
                      <InputNumberWrapper
                        labelText='Nro Día Inicio'
                        name='nroDiaInicio'
                        textPlaceholder='Escribe el dia inicio'
                        required
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <InputNumberWrapper
                        labelText='Nro Día Fin'
                        name='nroDiaFin'
                        textPlaceholder='Escribe el dia fin'
                        required
                      />
                    </div>
                  </>
                )}

                <div className='col-sm-12 col-lg-3'>
                  <div>
                    <label className=''>Mes Completo</label>
                    <div className='sdx_form_input'>
                      <div className='form-check form-switch form-check-custom form-check-solid'>
                        <Controller
                          name={'mesCompleto'}
                          control={control}
                          render={({field}) => (
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id='switchActivaExpresion'
                              onChange={(e) => {
                                field.onChange(e)
                                handleChangeMesCompleto(e)
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button
                  label='Buscar'
                  onClick={handleSubmit(onSubmit)}
                  loading={searching}
                  disabled={searching}
                />
                <Button label='Limpiar' onClick={handleClear} />
              </ButtonWrapper>
            </form>
          </FormProvider>
        </div>
        <div className='position-relative'>
          {searching || (loading && <KTableLoading />)}
          <div>
            <div className='d-flex flex-row justify-content-between'>
              <div>
                {optionText === 'dayli' && (
                  <button
                    className='btn border border-gray-400 fs-8 ms-4 px-4 p-2'
                    onClick={handleBackToMonthly}
                  >
                    Volver a vista mensual
                  </button>
                )}
              </div>
              <div>
                {tituloGrafico !== '' && (
                  <div className='alert alert-warning' style={{fontSize: '20px'}}>
                    <b style={{color: 'black'}}>{tituloGrafico}</b>
                  </div>
                )}
              </div>
              <div className='me-2'>
                <div className='alert alert-success' style={{fontSize: '18px'}}>
                  Promedio de Estadias: <b>{(promedioEstadias || 0).toFixed()}</b>
                </div>
                {optionText === 'dayli' && (
                  <div className='alert alert-success' style={{fontSize: '18px'}}>
                    Total de Estadias: <b>{totalEstadias || 0}</b>
                  </div>
                )}
                {optionText === 'dayli' && (
                  <div className='d-flex me-auto justify-content-end mb-2'>
                    <Button
                      typeBtn='button'
                      label='Descargar'
                      onClick={handleExportXLS}
                      loading={isDownloadXLS}
                      disabled={isDownloadXLS}
                    />
                  </div>
                )}
              </div>
            </div>
            <Chart options={chartData} series={chartData.series} height={600} type='line' />
          </div>
        </div>

        {hasData && (
          <TableReportOccupancy
            selectedOption={valueForm}
            setChangeDate={setChangeDate}
            changeDate={changeDate}
            showSearch={showSearch}
            setIsSearchEmp={setIsSearchEmp}
            setIdEmpresa={setIdEmpresa}
          />
        )}
      </KTCard>
    </>
  )
}

export {ReportOccupancy}
